import jwtAuthAxios from "../auth/jwtAuth";
import { setBackendDomain } from "./management";

export const getAccessSystemSettings = async () => {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.get(`/api/v1/access-system/settings`);
  return data;
};

export const updateAccessSystemSettings = async (payload) => {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.put(
    `/api/v1/access-system/settings`,
    payload,
  );
  return data;
};

export const resetAccessSystemSettings = async () => {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.post(
    `/api/v1/access-system/settings/reset`,
  );
  return data;
};

export const openAccessSystemTurnstile = async (payload) => {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.post(
    `/api/v1/access-system/turnstile/open`,
    payload,
  );
  return data;
};

/**
 * POST /api/v1/access-system/compressor/start
 * Body: { customerId, workspaceId, deviceId }. Pulses the compressor Start relay via DLA.
 */
export const startAccessSystemCompressor = async (payload) => {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.post(
    `/api/v1/access-system/compressor/start`,
    payload,
  );
  return data;
};

/**
 * POST /api/v1/access-system/compressor/stop
 * Body: { customerId, workspaceId, deviceId }. Pulses the compressor Disable relay via DLA.
 */
export const stopAccessSystemCompressor = async (payload) => {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.post(
    `/api/v1/access-system/compressor/stop`,
    payload,
  );
  return data;
};

/**
 * GET /api/v1/access-system/vouchers
 * @param {{ page?: number, limit?: number }} [params] query params e.g. { page: 1, limit: 20 }
 * @returns {Promise<{ success?: boolean, data?: unknown[], pagination?: object } & Record<string, unknown>>}
 */
export const getAccessSystemVouchers = async (params) => {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.get(`/api/v1/access-system/vouchers`, {
    params: params && Object.keys(params).length ? params : undefined,
  });
  return data;
};

/**
 * GET /api/v1/access-system/vouchers/:id
 * @param {string} id voucher series id (e.g. Mongo _id)
 * @param {{ customerId?: string }} [opts] — optional query: logged-in customer id
 * @returns {Promise<{ success?: boolean, data?: object } & Record<string, unknown>>}
 */
export const getAccessSystemVoucherById = async (id, opts = {}) => {
  setBackendDomain(jwtAuthAxios);
  const params = {};
  if (opts.customerId != null && String(opts.customerId).trim() !== "") {
    params.customerId = String(opts.customerId).trim();
  }
  const { data } = await jwtAuthAxios.get(
    `/api/v1/access-system/vouchers/${encodeURIComponent(String(id))}`,
    {
      params: Object.keys(params).length ? params : undefined,
    },
  );
  return data;
};

/** POST one voucher series object (not a wrapper with an array). */
export const saveAccessSystemVoucher = async (voucherSeries) => {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.post(
    `/api/v1/access-system/vouchers`,
    voucherSeries,
  );
  return data;
};

/**
 * PUT /api/v1/access-system/vouchers/:id — update existing voucher series (same body shape as POST).
 * @param {string} voucherId
 * @param {object} voucherSeries
 */
export const updateAccessSystemVoucher = async (voucherId, voucherSeries) => {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.put(
    `/api/v1/access-system/vouchers/${encodeURIComponent(String(voucherId))}`,
    voucherSeries,
  );
  return data;
};

/**
 * POST /api/v1/access-system/vouchers/print — bulk print selected voucher codes.
 * @param {object} payload — e.g. { codes, customerId, workspaceUuid, printerUuid, voucherId?, connectionCode? }
 */
export const printAccessSystemVouchers = async (payload) => {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.post(
    `/api/v1/access-system/vouchers/print`,
    payload,
  );
  return data;
};
